import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Base URL for production
const BASE_URL = 'https://transfertdebillets.ca';

// SEO configuration for each page
// Note: Middleman sécurise les transferts de billets entre particuliers - nous ne vendons pas de billets
const seoConfig = {
  '/': {
    title: 'Middleman - Transfert sécurisé de billets entre particuliers | Québec',
    description: 'Sécurisez vos transferts de billets électroniques entre particuliers. Intermédiaire de confiance, vérification des billets, protection des deux parties au Québec.',
    keywords: 'transfert billets sécurisé, intermédiaire confiance, tiers neutre, transfert entre particuliers, Québec',
    type: 'website'
  },
  '/events': {
    title: 'Événements à venir | Middleman - Québec',
    description: 'Consultez les événements à venir au Québec. Besoin de transférer des billets de façon sécurisée? Middleman est votre intermédiaire de confiance.',
    keywords: 'événements Québec, concerts Montréal, spectacles, transfert billets sécurisé',
    type: 'website'
  },
  '/faq': {
    title: 'FAQ - Questions fréquentes | Middleman',
    description: 'Comment fonctionne Middleman? Nous sécurisons les transferts de billets entre particuliers. Découvrez notre service de vérification des billets.',
    keywords: 'FAQ Middleman, comment ça marche, transfert sécurisé, vérification billets',
    type: 'website'
  },
  '/contact': {
    title: 'Contactez-nous | Middleman - Support',
    description: 'Besoin d\'aide pour sécuriser votre transfert de billets? Contactez l\'équipe Middleman. Support par chatbot, Messenger ou formulaire.',
    keywords: 'contact Middleman, support, aide transfert billets, service client',
    type: 'website'
  },
  '/facebook-groups': {
    title: 'Groupes Facebook affiliés | Middleman - Communauté',
    description: 'Rejoignez les groupes Facebook où les membres utilisent Middleman pour sécuriser leurs transferts de billets entre particuliers.',
    keywords: 'groupes Facebook billets, communauté Québec, transfert sécurisé Facebook',
    type: 'website'
  },
  '/fraud-cases': {
    title: 'Cas de fraudes | Middleman - Protection',
    description: 'Consultez les cas de fraudes signalés. Middleman vous aide à éviter les arnaques en sécurisant vos transferts de billets entre particuliers.',
    keywords: 'fraude billets, arnaques, prévention de fraude, sécurité transfert',
    type: 'website'
  },
  '/privacy-policy': {
    title: 'Politique de confidentialité | Middleman',
    description: 'Découvrez comment Middleman protège vos données personnelles lors de la sécurisation de vos transferts de billets.',
    keywords: 'politique confidentialité, données personnelles, vie privée',
    type: 'website'
  },
  '/terms-of-use': {
    title: 'Conditions d\'utilisation | Middleman',
    description: 'Consultez les conditions d\'utilisation du service Middleman de sécurisation de transfert de billets entre particuliers.',
    keywords: 'conditions utilisation, termes service, CGU',
    type: 'website'
  },
  '/create-transaction': {
    title: 'Créer un transfert sécurisé | Middleman',
    description: 'Initiez un transfert de billets sécurisé entre vous et un autre particulier. Middleman agit comme tiers neutre.',
    keywords: 'créer transfert sécurisé, transaction sécurisée, intermédiaire de confiance',
    type: 'website'
  }
};

const SEOHead = ({ customTitle, customDescription, customImage }) => {
  const location = useLocation();
  const path = location.pathname;
  
  // Get config for current path or use default
  const config = seoConfig[path] || seoConfig['/'];
  
  const title = customTitle || config.title;
  const description = customDescription || config.description;
  const image = customImage || `${BASE_URL}/logo-dark-clean.png`;
  const url = `${BASE_URL}${path}`;
  
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta tags
    const updateMetaTag = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, value);
      }
    };
    
    // Primary meta tags
    updateMetaTag('meta[name="description"]', 'content', description);
    updateMetaTag('meta[name="keywords"]', 'content', config.keywords);
    
    // Open Graph
    updateMetaTag('meta[property="og:title"]', 'content', title);
    updateMetaTag('meta[property="og:description"]', 'content', description);
    updateMetaTag('meta[property="og:url"]', 'content', url);
    updateMetaTag('meta[property="og:image"]', 'content', image);
    updateMetaTag('meta[property="og:type"]', 'content', config.type);
    
    // Twitter
    updateMetaTag('meta[name="twitter:title"]', 'content', title);
    updateMetaTag('meta[name="twitter:description"]', 'content', description);
    updateMetaTag('meta[name="twitter:url"]', 'content', url);
    updateMetaTag('meta[name="twitter:image"]', 'content', image);
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    }
    
  }, [path, title, description, image, url, config]);
  
  return null; // This component doesn't render anything
};

export default SEOHead;
